import HighlightText from '@viking-eng/highlight-text';
import PropTypes from '@viking-eng/prop-types';
import classNames from 'classnames';
import React from 'react';
import { components } from 'react-select';
import './Option.css';

const Option = (props) => {
  const {
    data: { hasDivider, customOptionHtml },
    label,
    selectProps: { isHighlightable, inputValue },
  } = props;

  if (typeof label === 'string' || React.isValidElement(label)) {
    if (isHighlightable) {
      return (
        <components.Option className={classNames({ divider: hasDivider })} {...props}>
          <HighlightText highlightTerm={inputValue} text={label} />
        </components.Option>
      );
    }
    return <components.Option {...props}>{customOptionHtml || label}</components.Option>;
  }

  if (!Array.isArray(label)) {
    throw new Error('Option label type not supported. Must be string or array of strings.');
  }

  return (
    <components.Option {...props}>
      <div className="option">
        {label.map((line) => {
          const renderLine = isHighlightable ? <HighlightText highlightTerm={inputValue} text={line} /> : line;
          return (
            <div className="option-line" key={line}>
              {renderLine}
            </div>
          );
        })}
      </div>
    </components.Option>
  );
};

export default Option;

Option.propTypes = {
  data: PropTypes.shape({
    hasDivider: PropTypes.bool,
    customOptionHtml: PropTypes.any,
  }),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.jsx]).isRequired,
  selectProps: PropTypes.shape({
    inputValue: PropTypes.any,
    isHighlightable: PropTypes.bool,
  }),
};

Option.defaultProps = {
  data: {},
  selectProps: {},
};
